import React from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faReact,
  faNode,
  faSquareJs,
  faPython,
  faHtml5,
  faCss3Alt,
  faGitAlt,
} from "@fortawesome/free-brands-svg-icons";
import { faDatabase } from "@fortawesome/free-solid-svg-icons";
import { SiNextdotjs, SiFlask } from "react-icons/si";
import { RiTailwindCssFill } from "react-icons/ri";

const skills = [
  { icon: faReact, color: "#61DBFB", name: "React" },
  { icon: faSquareJs, color: "#facc15", name: "JavaScript" },
  { icon: faNode, color: "#22c55e", name: "Node.js" },
  { icon: faPython, color: "#3b82f6", name: "Python" },
  { icon: faHtml5, color: "#ef4444", name: "HTML5" },
  { icon: faCss3Alt, color: "#3b82f6", name: "CSS3" },
  { icon: SiNextdotjs, color: "#fff", name: "Next.js", type: "react-icon" },
  { icon: SiFlask, color: "#fff", name: "Flask", type: "react-icon" },
  {
    icon: RiTailwindCssFill,
    color: "#38BDF8",
    name: "Tailwind CSS",
    type: "react-icon",
  },
  {
    icon: RiTailwindCssFill,
    color: "#38BDF8",
    name: "NativeWind",
    type: "react-icon",
  },
  { icon: faReact, color: "#764ABC", name: "Redux Toolkit" },
  { icon: faReact, color: "#A855F7", name: "Zustand" },
  { icon: faGitAlt, color: "#f97316", name: "Git" },
  { icon: faDatabase, color: "#22c55e", name: "SQL" },
];

export default function Skills() {
  return (
    <section className="relative overflow-hidden bg-custombg py-24 px-6">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-[450px] w-[450px] rounded-full bg-purple-500/20 blur-[120px]" />
        <div className="absolute -bottom-24 -right-24 h-[500px] w-[500px] rounded-full bg-blue-500/20 blur-[140px]" />
        <div className="absolute top-1/3 left-1/2 h-[320px] w-[320px] -translate-x-1/2 rounded-full bg-pink-500/20 blur-[120px]" />
        <div className="absolute top-20 right-1/4 h-[220px] w-[220px] rounded-full bg-cyan-400/20 blur-[100px]" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.04)_1px,transparent_1px)] bg-[size:40px_40px]" />
      <div className="absolute inset-0 opacity-[0.03] bg-[url('https://grainy-gradients.vercel.app/noise.svg')]" />
      <div className="relative mx-auto max-w-7xl">
        <div className="mb-16 text-center">
          <p className="uppercase tracking-[0.35em] text-yellow-400 font-semibold">
            Technologies
          </p>
          <h2 className="mt-4 text-5xl font-bold text-white">
            My <span className="text-yellow-400">Skills</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-gray-400">
            Technologies I use to build modern, scalable web and mobile
            applications.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {skills.map((skill, i) => (
            <motion.div
              key={skill.name}
              initial={{ opacity: 0, y: 25 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, scale: 1.03 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="group rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl p-4 flex flex-col items-center hover:border-yellow-400/40 hover:bg-white/10"
            >
              <div className="flex h-20 w-20 items-center justify-center rounded-2xl border border-white/10 bg-black/20 group-hover:shadow-[0_0_35px_rgba(250,204,21,.35)]">
                {skill.type === "react-icon" ? (
                  <skill.icon size={42} color={skill.color} />
                ) : (
                  <FontAwesomeIcon
                    icon={skill.icon}
                    style={{ color: skill.color }}
                    className="text-5xl"
                  />
                )}
              </div>
              <h3 className="mt-5 text-lg font-semibold text-white">
                {skill.name}
              </h3>
              {/* <p className="mt-2 text-xs text-gray-400">Production Ready</p> */}
              {/* <span className="mt-5 rounded-full border border-yellow-400/30 bg-yellow-400/10 px-3 py-1 text-xs text-yellow-300">
                Experienced
              </span> */}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
